<template>
  <CardTable
    :loading="loadingCycles"
    header="Cycle History"
    :tableHeaders="headers"
    :tableData="recentCycleTableData"
    :allTableData="recentCycleList"
  />
</template>

<script>
import CardTable from '@shared/components/service/component/CardTable.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'CycleHistoryTable',
  components: { CardTable },
  data() {
    return {
      headers: [{
        text: 'Date',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'date',
      }, {
        text: 'Time',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'time',
      }, {
        text: 'Runtime',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'runtime',
      }, {
        text: 'OA Temp/RH',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'oaTemp',
      }, {
        text: 'Sup/Ret',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'supRet',
      }, {
        text: 'Performance',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'performance',
      }, {
        text: 'Delta P',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'deltaP',
      }],
    };
  },
  computed: {
    ...mapState({
      loadingCycles: (state) => state.service.loadingCycles,
      recentCycleList: (state) => state.service.recentCycleList,
      serviceInfo: (state) => state.service.serviceInfo,
    }),
    ...mapGetters([
      'recentCycleTableData',
    ]),
  },
};
</script>
